export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('page:start', () => {
    const { $i18n } = useNuxtApp();


    // Находим все ссылки без префикса локали
    const links = document.querySelectorAll('a[href^="/"]');

    links.forEach(link => {
      const href = link.getAttribute('href');

      // Проверяем, начинается ли ссылка с локали
      const hasLocalePrefix = /^\/[a-z]{2}\//.test(href);

      // Если нет префикса локали, добавляем его
      if (!hasLocalePrefix && !href.startsWith('/api/') && !href.startsWith('/assets/')) {
        link.setAttribute('href', `/${$i18n.locale.value}${href}`);
      }
    });
  });
});
